import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { mediaApi } from "../api";
import MediaCard from "../components/MediaCard";

export default function MediaFavorites() {
  const [items, setItems] = useState(null);
  useEffect(() => { mediaApi.favorites().then(setItems).catch(() => setItems([])); }, []);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="px-4 md:px-8 lg:px-12 py-12 max-w-[1600px] mx-auto"
      data-testid="media-favorites-page"
    >
      <div className="flex items-center gap-3 mb-10">
        <Heart className="text-[#D1CFC9]" />
        <div>
          <p className="text-xs tracking-[0.3em] uppercase text-[#D1CFC9] font-bold mb-1">A tua coleção</p>
          <h1 className="font-serif text-5xl font-light">Favoritos</h1>
        </div>
      </div>
      {items === null ? (
        <div className="live-dot" />
      ) : items.length === 0 ? (
        <div className="text-center py-20 text-slate-400" data-testid="media-favorites-empty">
          <Heart size={48} className="mx-auto mb-4 text-slate-700" />
          <p>Ainda não marcaste favoritos. Explora o Media Center e adiciona os teus preferidos.</p>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6">
          {items.map((i) => <MediaCard key={i.ID_ConteudoMediaCenter} item={i} fluid />)}
        </div>
      )}
    </motion.div>
  );
}
